import ReactDOM from "react-dom";
import App from "./App";
import "./assets/scss/style.scss";
import React from 'react'
ReactDOM.render(<App />, document.getElementById(
    'root'));
